import { injectable } from "inversify";
import jwt_decode from "jwt-decode";
import { AppService, Types } from "../../AccessControl/AccessControlTypes";

export interface IAuthorisationManagementService {

    DoesCurrentUserMatchProvidedUserGuid(userId: string): boolean;
}

@injectable()
export default class AuthorisationManagementService implements IAuthorisationManagementService {
    constructor(
        private authService = AppService.get(Types.Neo.Security.AuthenticationService)) {
    }
    
    public DoesCurrentUserMatchProvidedUserGuid(userGuid: string): boolean {
        var user = this.authService.user;
        var accessTokenDecoded = jwt_decode(this.authService.user?.accessToken ? this.authService.user?.accessToken : "");
        var accessTokenDecodedString = JSON.stringify(accessTokenDecoded);
        var accessTokenDecodedSubstring = accessTokenDecodedString.substring(accessTokenDecodedString.lastIndexOf('"sub":"') + 7, accessTokenDecodedString.lastIndexOf('"sub":"') + 43);
    
        if (user !== undefined && user?.userName !== "" && accessTokenDecodedSubstring !== "" && userGuid !== "") {
            return accessTokenDecodedSubstring === userGuid;
        }
        return false;
    }
}